import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {

        width: '100%',
        borderRadius: '4px',
        minHeight: '102px',
        padding: '11px 15px',
        display:'flex',
        flexDirection:'column',
        gap:'9px',
        '.lightTheme &':{
            backgroundColor: '#f7f7f7',
            boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.15)',
        },
        '&.active':{
            backgroundColor: '#97dffe',
            border:'1px dashed #1390c7'
        }
    },
    name: {
        color: '#8d8d8f',
        fontSize: '12px',
        fontWeight: '600'
    },
    description:{
        color: 'rgba(141, 141, 143, 0.5)',
        fontSize: '10px',
    }
}